import React from 'react'
import PropTypes from 'prop-types'

/**
 * HeaderCell component for BaseTable
 */
const TableHeaderCell = ({ className, column, columnIndex }) => {
  return (
    <div className={className}>
      <div className="flex items-center">{column.title}</div>
    </div>
  )
}

TableHeaderCell.propTypes = {
  className: PropTypes.string,
  column: PropTypes.object,
  columnIndex: PropTypes.number,
}

export default TableHeaderCell
